module.exports = __webpack_public_path__ + "img/logo-CBM-2.3c4e675f.png";